/*
  Модуль онлайн диагностики
*/
import $ from 'jquery';

$.fn.onlineDiagnostic = function(options) {
  return this.each(function(index, el) {
    var containerScrollTop = $(this).position().top;
    var $frame = $('.js_online_diagnostic_frame', $(this));
    var $start = $('.js_online_diagnostic_start', $(this));
    var $restartContainer = $('.js_online_diagnostic_restart_container', $(this));
    var $restart = $('.js_online_diagnostic_restart', $(this));
    var $backContainer = $('.js_online_diagnostic_back_container', $(this));
    var $back = $('.js_online_diagnostic_back', $(this));
    var isLoading = false;
    var currentStep;
    var states = [];
    var data;
    
    if (isLoading) {
      return;
    }

    $start.on('click', function(e) {
      e.preventDefault();

      if (isLoading) {
        return;
      }

      isLoading = true;
      $start.addClass('m_loading');

      $.get('/wp-admin/admin-ajax.php', {
          action: 'get_diagnostic_data'
        }, 
        handleData, 
        'json'
      )
      .always(function() {
        isLoading = false;
        $start.removeClass('m_loading');
      });
    });

    $frame.on('click', '.js_online_diagnostic_answer', function(e) {
      var url = $(this).attr('href');

      if (url.indexOf('#') !== -1) {
        e.preventDefault();
        states.push(url.slice(1));
        showStep(url.slice(1));
      }
    });

    $restart.on('click', function(e) {
      e.preventDefault();
      start();
    });

    $back.on('click', function(e) {
      e.preventDefault();
      var currentState = states.pop();
      var prevState = states[states.length - 1];
      showStep(prevState);
    })

    function handleData(d) {
      data = d;
      start();
    }

    function start() {
      states = ['question-1'];
      showStep('question-1');
      $restartContainer.fadeOut();
      $backContainer.fadeOut();
    }

    function showStep(stepName) {
      var type = getStepType(stepName);
      var stepData = data[stepName];
      var html;
      
      switch(type) {
        case 'question':
          html = buildQuestionHtml(stepData);
          break;
        case 'work':
          html = buildWorkHtml(stepData);
          break;
        case 'article':
          html = buildArticleHtml(stepData);
          break;
      }

      
      var scrollTop = $(document).scrollTop();
      $frame.fadeOut(200, function() {
        $frame
          .html('')
          .append(html)
          .fadeIn();

        if (type !== 'question') {
          $restartContainer.fadeIn();
        } else {
          $restartContainer.hide();
        } 

        if (states.length > 1) {
          $backContainer.fadeIn();
        } else {
          $backContainer.hide();
        }

        if (scrollTop > containerScrollTop) {
          $('html, body').animate({
            scrollTop: containerScrollTop
          }, 300);
        }
      });

      if (window.location.host === 'www.bzone-service.ru') {
        ga('send', 'event', 'online-diagnostic', 'show-step', stepName);
      }
    }

    function getStepType(stepName) {
      return stepName.split('-').shift();
    }

    function buildQuestionHtml(questionData) {
      var container = $('<div />');
      var question = $('<div />', {
        class: 'online_diagnostic_question',
        text: questionData.question
      });
      var answers = $('<div />', {
        class: 'online_diagnostic_answers'
      });
      
      $.each(questionData.answers, function(answer, link) {
        answers.append(getLink(answer, link));
      });

      return container
              .append(question)
              .append(answers);
    }

    function buildWorkHtml(workData) {
      var container = $('<div />');
      var text = $('<div />', {
        class: 'online_diagnostic_question',
        text: 'Возможные работы:'
      });
      var works = $('<div />', {
        class: 'h_text_align_center'
      });

      $.each(workData, function(index, work) {
        var work = $('<span/>', {
          class: 'online_diagnostic_work',
          text: work
        });

        if (index !== 0) {
          works.append(' / ')
        }
        works.append(work);
      });

      return container
              .append(text)
              .append(works);
    }

    function buildArticleHtml(articleData) {
      var container = $('<div />');
      var text = $('<div />', {
        class: 'online_diagnostic_question',
        text: 'Данная статьи могут быть для вас полезными:'
      });
      var artciles = $('<div />', {
        class: 'online_diagnostic_answers'
      });

      $.each(articleData, function(index, article) {
        artciles.append(getLink(article.title, article.url, true));
      });

      return container
              .append(text)
              .append(artciles);
    }

    function getLink(title, link, newPage) {
      var url = newPage ? link : '#' + link;

      return $('<a />', {
        class: 'online_diagnostic_answer js_online_diagnostic_answer',
        href: url,
        text: title,
        target: '_blank'
      });
    }

    
  });
}

export default function() {
  $('.js_online_diagnostic').onlineDiagnostic();
}
